// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"13771ec8","764":"d6a98f7d","828":"08a60996","953":"357bb107"}[chunkId] + ".chunk.css";
};